import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconStackedBarChart2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconStackedBarChart2"><Path d="M21 18.5H22V20H2V18.5H3V11H6.5V18.5H7.5V6H11V18.5H13V9H16.5V18.5H17.5V4H21V18.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconStackedBarChart2;
